import React, { ReactElement, useState } from "react";
import Avatar from "react-avatar";
import { Col, Row } from "react-bootstrap";

import moment from "moment";

import ReactMarkdown from "react-markdown";
import { ProjectTask, ProjectTaskComment, ProjectTaskCommentForm } from ".";
import { Editable } from "../ui";
interface IProps {
	comment: ProjectTaskComment;
	task: ProjectTask;
}

export const ProjectTaskCommentListItem = (props: IProps): ReactElement => {
	const [isEditing, setIsEditing] = useState(false);
	const [comment, setComment] = useState(props.comment);

	return (
		<Editable
			isEditing={isEditing}
			shownComponent={
				<Row className="action-log-item">
					<Col sm={1} className="avatar-column">
						<Avatar
							round
							name={comment.user ? comment.user.fullName : "NA"}
							size="30"
							color="#dfe1e6"
							fgColor="#172b4d"
							textSizeRatio={2}
						/>
					</Col>
					<Col>
						<strong>
							{comment.user ? comment.user.fullName : "NA"}
						</strong>{" "}
						<ReactMarkdown source={comment.comment} />
						<small>
							{comment.createdDate
								? moment(comment.createdDate).fromNow()
								: ""}
						</small>
					</Col>
				</Row>
			}
			editComponent={
				<ProjectTaskCommentForm
					comment={comment}
					task={props.task}
					onSave={updatedComment => {
						setIsEditing(false);
						setComment(updatedComment);
					}}
				/>
			}
			onStartedEditing={() => setIsEditing(true)}
			onFinishedEditing={() => {
				return;
			}}
		/>
	);
};
